import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import SocialProof from './components/SocialProof';
import ExitIntent from './components/ExitIntent';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <SocialProof />
        <ExitIntent />
        <Toaster position="top-right" richColors />
      </div>
    </Router>
  );
}

export default App;
